export default __webpack_public_path__ + "static/media/unknown.053aec7b.svg";